import { render, staticRenderFns } from "./EditPersonInCharge.vue?vue&type=template&id=d79dfd04"
import script from "./EditPersonInCharge.vue?vue&type=script&lang=js"
export * from "./EditPersonInCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports